// function to sort the data
// data=>array
// type=> type of sorting
// value=> what value in data is sorted
// direction ASC or DSC

const sortHelper = (array, type, value, direction) => {
  // TYPE STRING
  if (type === "string" && array?.length > 0) {
    if (direction === "ASC") {
      return array?.sort((a, b) => a[value].localeCompare(b[value]))
    } else if (direction === "DSC") {
      return array?.sort((a, b) => b[value].localeCompare(a[value]))
    } else {
      return array?.sort((a, b) => a.id - b.id)
    }
  } else if (type === "duration" && array?.length > 0) {
    if (direction === "ASC") {
      return array?.sort(
        (a, b) =>
          Number(a?.video?.duration || 0) - Number(b?.video?.duration || 0),
      )
    } else if (direction === "DSC") {
      return array?.sort(
        (a, b) =>
          Number(b?.video?.duration || 0) - Number(a?.video?.duration || 0),
      )
    } else {
      return array?.sort((a, b) => a.id - b.id)
    }

    // TYPE NUMBER
  } else if (type === "number" && array?.length > 0) {
    //change the value to lesson_count that is how is coming in the data base
    if (value === "lessons") {
      value = "lesson_count"
    } else if (value === "labs") {
      value = "lab_id"
    } else if (value === "learning paths") {
      value = "learning_paths_count"
    } else if (value === "type") {
      value = "fixed"
    } else if (value === "used") {
      value = "uses"
    }
    // The 'fixed' value, represented as either 1 or 0, indicating whether it is fixed or a percentage.
    // For this reason, the order needs to be reversed
    if (direction === "ASC") {
      return array?.sort((a, b) =>
        value !== "fixed" ? a[value] - b[value] : b[value] - a[value],
      )
    } else if (direction === "DSC") {
      return array?.sort((a, b) =>
        value !== "fixed" ? b[value] - a[value] : a[value] - b[value],
      )
    } else {
      return array?.sort((a, b) => a.id - b.id)
    }

    // TYPE DATE
  } else if (type === "date" && array?.length > 0) {
    if (value === "last updated") {
      value = "updated"
    } else if (value === "start date") {
      value = "start_date"
    } else {
      value = "end_date"
    }
    if (direction === "ASC") {
      return array.sort((a, b) => a[value].unix() - b[value].unix())
    } else if (direction === "DSC") {
      return array.sort((a, b) => b[value].unix() - a[value].unix())
    } else {
      return array?.sort((a, b) => a.id - b.id)
    }
  }

  // TYPE LENGTH
  else if (type === "length" && array?.length > 0) {
    if (value === "courses") {
      value = "courses"
    } else {
      value = "access_codes"
    }
    if (direction === "ASC") {
      return array.sort((a, b) => a[value].length - b[value].length)
    } else if (direction === "DSC") {
      return array.sort((a, b) => b[value].length - a[value].length)
    } else {
      return array?.sort((a, b) => a.id - b.id)
    }
  }
}

export default sortHelper
